import React, { useState } from "react";
import Comments from "./Comments";

const FormComments = ({ comments, commentsFactory }) => {
  const [showFormComment, setShowFormComment] = useState(false);

  return (
    <>
      {comments.length > 0 && (
        <div className="w-100 text-end text-warning">
          <i
            className="fas fa-comment-alt mt-2 me-2"
            onClick={() => setShowFormComment(!showFormComment)}
          ></i>
        </div>
      )}
      {showFormComment && (
        <Comments
          comments={comments}
          commentsFactory={commentsFactory}
          showNavigation
        />
      )}
    </>
  );
};

export default FormComments;
